import React, { useEffect, useState, useRef }  from 'react';
import ReactDOM from "react-dom/client";

import { OPTIONS, optionPathByIndex, optionIndexByPath } from './Options.jsx'

import HealingMenu from './HealingMenu.jsx'

import ahoy from "ahoy.js"

const PreloadWrapper = ({ is_active, children }) => {
	const hide_class = is_active ? 'z-1' : 'w-full h-full top-0 left-0 absolute z-[-10] pointer-events-none'

	return (<div
		className={`${hide_class}`}
		style={{
			opacity: is_active ? '1' : '0.001'
		}}
	>
		{children}
	</div>)
}

const HealingExperience = ({ path, title_template_string }) =>{
	const title_template = _.template(title_template_string)

	const [selected_option, setSelectedOption] = useState(optionIndexByPath(path))
	const selected_option_ref = useRef(selected_option)

	const isRootLocation = () => window.location.pathname === '/'
	const setTitle = new_title => {
		const full_title = title_template({ humanized_experience_name: new_title })

		document.title = full_title
		window.title = full_title
	}

	const setTitleToDefault = () => setTitle(null)

	const [option_display_name] = OPTIONS[selected_option] || []

	useEffect(()=>{
		setTitle(option_display_name)

		const onPopState = ()=>{
			console.log('HealingExperience#onPopState', document.location)

			if(isRootLocation()){
				setTitleToDefault()

				ahoy.trackView()
			}
			//setSelectedOption(null)
			//console.log(document.location)
			//console.log(event.state)
		}

		window.addEventListener('popstate', onPopState)

		return ()=> window.removeEventListener('popstate', onPopState)
	}, [])

	useEffect(()=>{
		console.log("HealingExperience#useEffect() new location", window.location)
	}, [window.location])

	useEffect(()=>{
		if(selected_option != selected_option_ref.current){
			selected_option_ref.current = selected_option

			if(option_display_name){
				setTitle(option_display_name)
				ahoy.trackView()
			}
		}
	}, [selected_option])

	const navigate = path => {
		history.pushState({}, '', path)
	}

	const onOptionSelect = option_index => {
		console.log("HealingExperience onOptionSelect", option_index)

		setSelectedOption(option_index)

		navigate(optionPathByIndex(option_index))
	}

	const onOptionBack = () => {
		if(!isRootLocation()){
			history.back()
		}
		setSelectedOption(-1)
	}

	const options = OPTIONS.map(([, , OptionComponent], option_index) => (
		<PreloadWrapper is_active={selected_option == option_index} key={'preload_wrapper_' + option_index}>
			<OptionComponent onBack={onOptionBack} is_active={selected_option == option_index} />
		</PreloadWrapper>)
	)

	const show_menu = selected_option === -1

	return (<>
		<PreloadWrapper is_active={show_menu}>
			<HealingMenu onOptionSelect={onOptionSelect} is_active={show_menu} />
		</PreloadWrapper>

		{options}
	</>
	)
}

export default HealingExperience
